import { render, staticRenderFns } from "./BrokerDashboard.vue?vue&type=template&id=5b76b579&scoped=true"
import script from "./BrokerDashboard.vue?vue&type=script&lang=js"
export * from "./BrokerDashboard.vue?vue&type=script&lang=js"
import style0 from "./BrokerDashboard.vue?vue&type=style&index=0&id=5b76b579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b76b579",
  null
  
)

export default component.exports